import React, {useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import BizLocationSelector from '../../../component/BizLocation/BizLocationSelector'
import DateSelector from '../../../component/Date/DateSelector'
import Page from '../../../component/Page/Page'
import {DashboardPage} from '../Dashboard/DashboardPage'

export function DashboardParkEvolutionPage() {

  const [bizLocationId, setBizLocationId] = useState(null)
  const [dateFilter, setDateFilter] = useState(null)

  return (
    <Page title="Status Geral">
      <Row>
        <Col md={12}>
          <Row>
            <Col md={7}>
              <BizLocationSelector setValue={setBizLocationId}/>
            </Col>
            <Col md={5}>
              <DateSelector title="Data" onChange={setDateFilter}/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DashboardPage bizLocationId={bizLocationId} dateFilter={dateFilter}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/StockLevel/Dashboard/DashboardParkEvolutionPage.js